import { useState, useEffect, useRef } from "react";
import { db, storage } from "./firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./index.css";

function Congresso() {
  const [eventoData, setEventoData] = useState(null); 
  const [grafismoData, setGrafismoData] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const eventoDocRef = doc(db, "evento", "bHueFt7pYOzNFTlaSOUg");
  const grafismoDocRef = doc(db, "evento_grafismo", "fNJWGGHLIFvQWsKdVBW5");
  const navbarBgRef = useRef(null);
  const navbarColorRef = useRef(null);
  const highlightColorRef = useRef(null);

  useEffect(() => {
    const fetchBoth = async () => {
      setLoading(true);
      setErrorMsg("");
      try {
        const [snapEvento, snapGrafismo] = await Promise.all([
          getDoc(eventoDocRef),
          getDoc(grafismoDocRef),
        ]);

        if (snapEvento.exists()) setEventoData(snapEvento.data());
        else setEventoData({});

        if (snapGrafismo.exists()) setGrafismoData(snapGrafismo.data());
        else setGrafismoData({});

      } catch (err) {
        console.error("Erro ao buscar documentos:", err);
        setErrorMsg("Erro ao carregar dados.");
      } finally {
        setLoading(false);
      }
    };

    fetchBoth();
  }, []);

  const handleColorChange = async (field, value) => {
    try {
      await updateDoc(eventoDocRef, { [field]: value });
      setEventoData((p) => ({ ...p, [field]: value }));
    } catch (err) {
      console.error("Erro ao actualizar cor:", err);
      setErrorMsg("Erro ao actualizar cor.");
    }
  };

  const handleToggleActive = async () => {
    try {
      const newValue = !Boolean(eventoData?.ativo);
      await updateDoc(eventoDocRef, { ativo: newValue });
      setEventoData((p) => ({ ...p, ativo: newValue }));
    } catch (err) {
      console.error("Erro ao trocar ativo:", err);
      setErrorMsg("Erro ao alterar estado do evento.");
    }
  };

  const handleImageUpload = (field) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      try {
        const storageRef = ref(
          storage,
          `spp-app-estrutura-evento-backoffice/${field}_${file.name}`
        );
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        await updateDoc(grafismoDocRef, { [field]: url });
        setGrafismoData((p) => ({ ...p, [field]: url }));
      } catch (err) {
        console.error("Erro upload/Firestore imagem:", err);
        setErrorMsg("Erro ao carregar imagem.");
      }
    };

    input.click();
  };

  const icons = [
    { label: "Welcome", field: "icon_boas_vindas" },
    { label: "Speakers", field: "icon_oradores" },
    { label: "Program", field: "icon_programa" },
    { label: "Event Map", field: "icon_mapa" },
    { label: "Exhibitors", field: "icon_expositores" },
    { label: "Sponsors", field: "icon_patrocinadores" },
    { label: "Works", field: "icon_trabalhos" },
    { label: "Awards", field: "icon_premios" },
    { label: "Information", field: "icon_informacoes" },
    { label: "Wall", field: "icon_mural" },
    { label: "Networking", field: "icon_networking" },
    { label: "Profile", field: "icon_perfil" },
  ];

  const newIcons = [
    { label: "Favorite Sessions", field: "icon_sessoes_favoritas" },
    { label: "Favorite Speakers", field: "icon_oradores_favoritos" },
    { label: "Favorite Exhibitors", field: "icon_expositores_favoritos" },
    { label: "Notes", field: "icon_notas" },
  ];

  if (loading) return <div>Carregando...</div>;

  return (
    <div className="dashboard-congress">
      {errorMsg && <div style={{ color: "red", marginBottom: 12 }}>{errorMsg}</div>}

      <div className="toggle-evento">
        <label>{eventoData?.ativo ? "Evento Ativo" : "Evento Inativo"}</label>
        <div className="toggle-evento-switch">
          <input
            type="checkbox"
            checked={!!eventoData?.ativo}
            onChange={handleToggleActive}
          />
          <span className="slider-evento" />
        </div>
      </div>

      <section>
        <h2>Ícones da App</h2>
        <div className="icons-grid">
          {[...icons, ...newIcons].map((icon, i) => (
            <div
              key={i}
              className="icon-item"
              onClick={() => handleImageUpload(icon.field)}
            >
              {grafismoData?.[icon.field] ? (
                <img src={grafismoData[icon.field]} alt={icon.label} className="icon-img" />
              ) : (
                <div className="icon-placeholder">+</div>
              )}
              <p>{icon.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        {[
          { label: "Icon do Evento", field: "evento_icon" },
          { label: "Banner principal", field: "banner_img" },
          { label: "Fundo principal", field: "fundo_principal" },
          { label: "Banner Brevemente", field: "banner_brevemente" },
        ].map((b, idx) => (
          <div key={idx} className="banner-item">
            <h2>{b.label}</h2>
            <div className="banner-box" onClick={() => handleImageUpload(b.field)}>
              {grafismoData?.[b.field] ? (
                <img src={grafismoData[b.field]} alt={b.label} className="banner-img" />
              ) : (
                <div className="banner-placeholder">+</div>
              )}
            </div>
          </div>
        ))}
      </section>

      <section>
        <div className="color-pickers">
          <div className="color-picker-group">
            <h2>Navbar Fundo:</h2>
            <div
              className="color-box"
              onClick={() => navbarBgRef.current && navbarBgRef.current.click()}
              style={{ backgroundColor: eventoData?.navbar_bg || "#ffffff" }}
            />
            <input
              ref={navbarBgRef}
              type="color"
              value={eventoData?.navbar_bg || "#ffffff"}
              onChange={(e) => handleColorChange("navbar_bg", e.target.value)}
              style={{ display: "none" }}
            />
          </div>

          <div className="color-picker-group">
            <h2>Navbar Texto:</h2>
            <div
              className="color-box"
              onClick={() => navbarColorRef.current && navbarColorRef.current.click()}
              style={{ backgroundColor: eventoData?.navbar_color || "#000000" }}
            />
            <input
              ref={navbarColorRef}
              type="color"
              value={eventoData?.navbar_color || "#000000"}
              onChange={(e) => handleColorChange("navbar_color", e.target.value)}
              style={{ display: "none" }}
            />
          </div>

          <div className="color-picker-group">
            <h2>Cor de destaque:</h2>
            <div
              className="color-box"
              onClick={() => highlightColorRef.current && highlightColorRef.current.click()}
              style={{ backgroundColor: eventoData?.highlight_color_1 || "#ffffff" }}
            />
            <input
              ref={highlightColorRef}
              type="color"
              value={eventoData?.highlight_color_1 || "#ffffff"}
              onChange={(e) => handleColorChange("highlight_color_1", e.target.value)}
              style={{ display: "none" }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Congresso;
